import { atom } from "recoil";
import { DEFAULT_KPI_IDS, kpiIdOrder } from "./kpiIds";

export const kpiSelectedAtom = atom<kpiIdOrder[]>({
  key: "KpiIds",
  default: DEFAULT_KPI_IDS.map((val, index) => ({ order: index, id: val })),
});

export const kpiColumnWidthAtom = atom<Map<number, number>>({
  key: "KpiColumnWidth",
  default: new Map<number, number>(),
});
